/**
 * Merge Tool (setup)
 * Entry point used by initRegistry.
 */

import { MergeToolController } from "./merge-tool-handler";
import { MergeToolListener } from "./merge-tool-listener";
import { MergeToolForm } from "./merge-tool-form";

export function initMergeTool(): void {
    const modal = MergeToolForm.findRoot();
    if (!modal) return;

    const controller = new MergeToolController(modal);
    new MergeToolListener().register(controller, modal);
}
